/**
 * Documents for DocumentViewer from an admin/presignFiles answer ({ urls: [{ url, type }] }).
 * @param {object} data
 * @returns {Array<{ uri: string, fileName: string, fileType: string }>}
 */
export const toPresignedDocs = (data) => {
  const urls = Array.isArray(data?.urls) ? data.urls : [];
  return urls.filter(Boolean).map((item) => {
    const href = item.url || item.uri || '';
    let originalFileName = '';
    try {
      const u = new URL(href);
      originalFileName = decodeURIComponent(
        (u.pathname.split('/').pop() || '').trim()
      );
    } catch (e) {
      const clean = href.split('?')[0].split('#')[0];
      originalFileName = decodeURIComponent(
        (clean.split('/').pop() || '').trim()
      );
    }
    return {
      uri: href,
      fileName: originalFileName || 'document',
      fileType: item.type || 'application/pdf',
    };
  });
};

export default toPresignedDocs;
